import { CashModal } from './CashModal';

export default CashModal;
